import { t } from "i18next";

export const externalTooltipHandler = (context: any) => {
  const { chart, tooltip } = context;

  // Find the dataset being hovered over to get its unit
  const hoveredDatasetIndex = tooltip.dataPoints?.[0]?.datasetIndex;
  const hoveredDataset = hoveredDatasetIndex !== undefined ? chart.data.datasets[hoveredDatasetIndex] : undefined;
  const unit = hoveredDataset?.unit || '';

  let tooltipEl = document.getElementById("chartjs-tooltip");

  if (!tooltipEl) {
    tooltipEl = document.createElement("div");
    tooltipEl.id = "chartjs-tooltip";
    tooltipEl.style.position = "absolute";
    tooltipEl.style.background = "rgb(255, 255, 255)";
    tooltipEl.style.color = "black";
    tooltipEl.style.padding = "6px 10px";
    tooltipEl.style.borderRadius = "4px";
    tooltipEl.style.border = "1px solid #ccc";
    tooltipEl.style.pointerEvents = "none";
    tooltipEl.style.fontSize = "12px";
    tooltipEl.style.fontWeight = "bold";
    tooltipEl.style.zIndex = "999";
    tooltipEl.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.1)";
    document.body.appendChild(tooltipEl);
  }

  // Hide if no tooltip
  if (tooltip.opacity === 0) {
    tooltipEl.style.opacity = "0";
    return;
  }

  // Set content
  if (tooltip.body) {
    const lines = tooltip.body.map((b: any) => {
      const label = b.lines[0].split(':')[0];
      const rawValue = b.lines[0].split(':')[1].trim();
      
      // Handle array-like string format [min, max]
      const values = rawValue.replace(/[\[\]]/g, '').split(',').map((v: string) => parseFloat(v.trim()));

      switch (unit) {
        case 'level':
        case 'temperature':
          return `${label}:<br>Min: ${values[0].toFixed(2)} ${unit}<br>Max: ${values[1].toFixed(2)} ${unit}`;
        default:
          return `${label}: ${values.join(', ')} ${unit}`;
      }
    });
    tooltipEl.innerHTML = lines.join("<br>");
  }

  const { canvas } = chart;
  const rect = canvas.getBoundingClientRect();

  tooltipEl.style.opacity = "1";
  tooltipEl.style.left = `${rect.left + window.pageXOffset + tooltip.caretX}px`;
  tooltipEl.style.top = `${rect.top + window.pageYOffset + tooltip.caretY}px`;
};
